import {Tiled}          from '@/domains/marketing/components/Backgrounds/Tiled';
import {SavvyCalButton}              from '@/domains/marketing/components/SavvyCalButton';
import {ArrowRightMovingOnHoverIcon} from '@/domains/shared/components/icons/ArrowRightMovingOnHoverIcon';
import {Button}                      from '@/domains/shared/components/Button';

export function CallToAction({
	                             title,
	                             subtitle,
	                             buttonType,
	                             buttonText,
	                             buttonHref,
                             }) {
	return (
		<div className="mt-12 not-prose text-left relative isolate overflow-hidden bg-gradient-to-br from-teal-600 to-teal-500/90 p-6 shadow-2xl rounded-lg sm:rounded-2xl sm:p-12 space-y-4">
			<h2 className="text-xl font-bold tracking-tight text-teal-50 sm:text-2xl leading-8">
				{title}
			</h2>

			{subtitle && <p className="text-lg leading-8 text-teal-100">
				{subtitle}
			</p>}

			{buttonType === 'href' && <Button color="white"
			                                  href={buttonHref}
			>
				{buttonText}

				<ArrowRightMovingOnHoverIcon />
			</Button>}

			{buttonType === 'savvycal' && <SavvyCalButton color="white">
				{buttonText}

				<ArrowRightMovingOnHoverIcon />
			</SavvyCalButton>}

			<Tiled className="absolute inset-0 translate-x-1/2 -translate-y-1/4 z-0 h-full w-full stroke-white [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
			       fillClass="fill-white/25"
			       tileSize={50}
			/>
		</div>);
}
